<template>
   <div class="feature-card">
      <img class="feature-card__image" :src="image" />
      <div class="feature-card__title h3">{{title}}</div>
      <div class="feature-card__content">
         <slot></slot>
      </div>
   </div>
</template>

<script>
export default {
   props: ["title", "image"]
}
</script>

<style lang="scss">
.feature-card {
  height: 310px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 12px 24px 0 rgba(3, 3, 3, 0.1);
  display: block;
  text-align: center;
  overflow: hidden;

  .feature-card__image {
    height: 100px;
    width: auto;
    margin: 32px 32px 0 32px;
  }

  .feature-card__title {
    margin-bottom: 10px !important;
    margin-left: 16px;
    margin-right: 16px;
  }

  .feature-card__content {
    padding: 0 16px 16px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/FeatureCard.vue